import { combineReducers } from "redux";
import create from "./create";
import restore from "./restore";
import userAction from "./user_action";
import verify from "./verify";
import notification from "./notification";

const appReducers = combineReducers({
  create,
  restore,
  userAction,
  verify,
  notification,
});

const rootReducer = (state, action) => {
  return appReducers(state, action);
};

export default rootReducer;
